import { ReactNode } from 'react'
import { createPortal } from 'react-dom'

import { useHasMounted } from '@lib/helpers'

interface InPortalProps {
  id: string
  children: ReactNode
}

const InPortal = ({ id, children }: InPortalProps) => {
  const hasMounted = useHasMounted()

  if (!hasMounted) {
    return null
  }

  const element = document.querySelector(`#${id}`)

  if (!element) {
    return null
  }

  return createPortal(children, element)
}

export default InPortal
